/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchRolesResponseItem } from './search-roles-response-item';


export interface SearchRolesResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchRolesResponseItem> | null;
}

